import React from "react";
import { useSelector } from "react-redux";

import { getIsSavingForm } from "../../redux/selectors";
import { CheckBoxOptionEnabler } from "../CheckBoxOptionEnabler";
import { DatePickerField } from "../DatePickerField";

type DatePickerWithCheckBoxFieldProps = {
  fieldName: string;
  label: string;
  selectedFieldName: string;
  dateFieldName: string;
};

export const DatePickerWithCheckBoxField = ({
  fieldName,
  label,
  selectedFieldName,
  dateFieldName,
}: DatePickerWithCheckBoxFieldProps) => {
  const isSavingFormToCrm = useSelector(getIsSavingForm);
  return (
    <CheckBoxOptionEnabler
      name={`${fieldName}.${selectedFieldName}`}
      text={label}
      isSaving={isSavingFormToCrm}
      key={fieldName}
    >
      <DatePickerField isSaving={isSavingFormToCrm} name={`${fieldName}.${dateFieldName}`} />
    </CheckBoxOptionEnabler>
  );
};
